import { createFileRoute } from "@tanstack/react-router";
import { QueueRequestViewPage } from "@/features/admin/queue/queue-request-view-page";

export const Route = createFileRoute("/admin/queue/$id/view")({
  component: RouteComponent,
  preload: false,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <QueueRequestViewPage requestId={id} />;
}
